import { PageHeader } from '@/components/shared/PageHeader';
import { useMarketplaceChain } from '@/hooks/use-marketplace-chain';
import { routes } from '@/utils/routes';
import { slugify } from '@/utils/slugify';
import { Container, Grid, GridItem } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { PropsWithChildren } from 'react';

type Props = {
  title: string;
  intro: string;
};

export const ArticleLayout = ({ title, intro, children }: PropsWithChildren<Props>) => {
  const { t } = useTranslation('common');
  const { route } = useRouter();

  const chain = useMarketplaceChain();

  return (
    <>
      <PageHeader
        title={title}
        subtitle={intro}
        pages={[
          { name: t('common:crumbs.home'), href: routes.home(chain.routePrefix) },
          { name: title, href: slugify(route) },
        ]}
        pb="space.16"
      />
      <Container pb={['4xl', null, '5xl']}>
        <Grid>
          <GridItem width={{ md: '80%' }} sx={{ li: { listStyle: 'inherit' } }}>
            {children}
          </GridItem>
        </Grid>
      </Container>
    </>
  );
};
